import { render, staticRenderFns } from "./PageForm.vue?vue&type=template&id=680cf09b&scoped=true"
import script from "./PageForm.vue?vue&type=script&lang=js"
export * from "./PageForm.vue?vue&type=script&lang=js"
import style0 from "./PageForm.vue?vue&type=style&index=0&id=680cf09b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680cf09b",
  null
  
)

export default component.exports